import "./InfoPopup.scss";
import { imageKeyMappings } from "../../../assets/images/imageKeyMappings";
import React, { useEffect } from "react";
import PubSub from "pubsub-js";

function Info({data}) {
  useEffect(()=>{
    console.log(data)
  },[data])
  const closeInfoPopup = () => {
    PubSub.publish('closeInfoPopup',{});
  };

  const pointsArray = data?.infoDescription.split('\n');
  console.log(pointsArray);
  return (
    <React.Fragment>
      <div className="exit-popup-component">
        <div className="bg full" onClick={closeInfoPopup}></div>
        <div className="exit-popup-content">
          <div className="content">
            <div className="info-header">
              <div className="coupon-title">
                <div className={data?.isBrandLogo ? "gift-icon brand-logo" : "gift-icon"}>
                  <img src={data?.imgurl}></img>
                </div>
                <div className="tnc-text">{data?.name}</div>
              </div>
              <div className="cross-icon" onClick={closeInfoPopup}>
                <img src={imageKeyMappings?.closeTncPopup} />
              </div>
            </div>
            {pointsArray.map((point, index) => (
               <div key={index} className="desc">{point}</div>
              ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Info;
